import React from 'react';
import GenderMarkerRows from '../components/GenderMarkerRows';
import ReportCard from '../components/ReportCard';
import RuleList from '../components/RuleList';
import { fmtPct, rankByPrevalence } from '../format';
import { Mono } from '../components/Emphasis';

/**
 * Which individual markers are driving the burden, split by gender. The side panel names the leading
 * marker and lists whichever markers came back under-sampled — both read off the payload.
 */
const MetabolicDrivers = ({ data }) => {
  const ranked = rankByPrevalence(data.markers);
  const leader = ranked[0];
  const caveated = data.markers.filter((marker) => marker.caveat);

  return (
    <div className='mt-ds-9 grid grid-cols-1 items-start gap-ds-5 lg:grid-cols-[1.5fr_1fr]'>
      <ReportCard fileName='metabolic-drivers' className='p-[26px]'>
        <h3 className='m-0 font-fig-extrabold text-[26px] font-bold leading-[1.18] text-gray-900'>
          Which tests are driving the numbers?
        </h3>
        <p className='mb-ds-5 mt-[6px] text-xs text-gray-600'>
          Share flagged abnormal on each marker, by gender
        </p>
        <GenderMarkerRows markers={data.markers} labelWidth={160} />
      </ReportCard>

      <div className='rounded-ds-lg border border-gray-300 bg-white p-[26px]'>
        <div className='mb-ds-4 text-ts-xs font-semibold uppercase tracking-[0.12em] text-ds-brand'>
          {leader ? `${leader.label} is the #1 issue` : 'Marker ranking'}
        </div>
        <RuleList
          mutedLast={caveated.length > 0}
          items={[
            leader ? (
              <>
                {leader.label} affects <Mono>{fmtPct(leader.prevalence)}</Mono> of those tested — the largest
                single contributor to the abnormality count.
              </>
            ) : null,
            ranked[1] ? (
              <>
                {ranked[1].label} follows at <Mono>{fmtPct(ranked[1].prevalence)}</Mono>
                {ranked[2] ? (
                  <>
                    , then {ranked[2].label} at <Mono>{fmtPct(ranked[2].prevalence)}</Mono>
                  </>
                ) : null}
                {' '}— the classic signature of rising insulin resistance.
              </>
            ) : null,
            caveated.length
              ? `* ${caveated.map((marker) => marker.label).join(' and ')} were only tested in a small subsample — true rates for these are likely higher.`
              : null,
          ]}
        />
      </div>
    </div>
  );
};

export default MetabolicDrivers;
